import React from 'react'
import { useCheckSomePermissions } from 'hooks/permissions'

type RestrictedProps = {
    permissions: string[]
    EmptyComponent?: React.ReactNode
}

const Restricted: React.FC<RestrictedProps> = ({ permissions, children, EmptyComponent }) => {
    const isShow = useCheckSomePermissions(permissions)

    if (isShow || permissions.length === 0) {
        return <>{children}</>
    }

    return <>{EmptyComponent ? EmptyComponent : null}</>
}

export default Restricted
